import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/contact")({
  head: () => {
    const title = "Contact MNRE | Mumbai Real Estate Advisory | Mohnish Nagpal";
    const description = "Contact Mohnish Nagpal Real Estate in Khar West, Mumbai. Inquire for luxury apartments, villas, society redevelopment, and BKC commercial offices.";
    const canonicalUrl = "https://mnre.in/contact";
    const ogImage = "https://mnre.in/blog-covers/mumbai-sealink-skyline.jpg";

    const breadcrumbJsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://mnre.in/" },
        { "@type": "ListItem", position: 2, name: "Contact", item: canonicalUrl },
      ],
    };

    const contactPageJsonLd = {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contact Mohnish Nagpal Real Estate",
      url: canonicalUrl,
      description: description,
      mainEntity: {
        "@type": "RealEstateAgent",
        name: "Mohnish Nagpal Real Estate",
        telephone: "+917021011304",
        email: "hello@mnre.in",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Ajanta Building, 3rd Road",
          addressLocality: "Khar West",
          addressRegion: "Mumbai, Maharashtra",
          postalCode: "400052",
          addressCountry: "IN",
        },
      },
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify([breadcrumbJsonLd, contactPageJsonLd]),
        },
      ],
    };
  },
  component: Contact,
});
